import { BASE_API_URL, BASE_NEW_API_URL } from '@/constants';
import axios, { AxiosError, AxiosInstance, InternalAxiosRequestConfig } from 'axios';

export const axiosInstance = axios.create({
  baseURL: BASE_API_URL,
  withCredentials: true,
});

export const axiosInstanceNewAPI = axios.create({
  baseURL: BASE_NEW_API_URL,
  withCredentials: true,
});

const attachErrorContext = (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  // eslint-disable-next-line no-param-reassign
  config.errorContext = new Error('Thrown at:');
  return config;
};

const describeRequest = (error: AxiosError): string => {
  const { config, response, code, message } = error;
  const method = config?.method ? config.method.toUpperCase() : 'UNKNOWN';
  const url = [config?.baseURL, config?.url].filter(Boolean).join('');
  const params = config?.params ? JSON.stringify(config.params) : undefined;

  const lines = [
    `Request failed: ${method} ${url || '(no url)'}`,
    params ? `Params: ${params}` : undefined,
    response ? `Response: ${response.status} ${response.statusText}` : 'Response: (no response)',
    code ? `Code: ${code}` : undefined,
    message ? `Message: ${message}` : undefined,
  ].filter(Boolean);

  return lines.join('\n');
};

const enrichError = async (error: AxiosError): Promise<never> => {
  const requestDetails = describeRequest(error);
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  const originalStackTrace = error.config?.errorContext?.stack as string | undefined;

  // eslint-disable-next-line no-param-reassign
  error.stack = [error.stack, requestDetails, originalStackTrace].filter(Boolean).join('\n');

  throw error;
};

const registerInterceptors = (instance: AxiosInstance): void => {
  instance.interceptors.request.use(attachErrorContext);
  instance.interceptors.response.use(undefined, enrichError);
};

registerInterceptors(axiosInstance);
registerInterceptors(axiosInstanceNewAPI);
